import React from 'react'

const Shimmers: React.FC = () => {
  return (
    <div className='absolute top-0 left-0 w-full h-full transition-all animate-loading duration-[2500]'>
      <div className=" w-1/2 h-[100%] bg-[rgba(255,255,255,0.3)] skew-x-[-20deg] shadow-[0_0_30px_30px_rgba(255,255,255,0.2)]"></div>
    </div>
  )
}

export default Shimmers;